import React, { useContext } from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { usePopover } from '../../../Popovers/redux/hooks';
import { PopoverType } from '../../../Popovers/redux/types';
import { getDeviationNotificationQueue } from '../../../DeviationPage/redux/helpers';
import AddToCollectionPopup from '../../_partials/AddToCollectionPopup';
import AddToPrivateCollectionButton from './AddToPrivateCollectionButton';
import PositionOnlyPopperPopover from '@wix/da-ds/pkg/popper/presets/PositionOnlyPopperPopover';
import type { OffsetModifier } from '@wix/da-ds/pkg/popper/types';

const offsetModifier: OffsetModifier = [0, 20];

export interface Props {
  deviation: PapiDeviation;
  actionBarType?: 'primary' | 'secondary';
}

const AddToPrivateCollectionButtonWithPopover: React.FC<Props> = ({
  deviation,
  actionBarType,
}) => {
  const isMobile = useContext(MobileContext);
  const { popover, removePopover, togglePopover } = usePopover(
    actionBarType === 'primary'
      ? PopoverType.ADD_TO_PRIVATE_COLLECTION_PRIMARY
      : PopoverType.ADD_TO_PRIVATE_COLLECTION_SECONDARY
  );
  const notificationQueue = isMobile
    ? 'default'
    : getDeviationNotificationQueue(deviation);

  return (
    <PositionOnlyPopperPopover
      popoverContent={
        <AddToCollectionPopup
          isPrivateCollections
          collectibleDeviation={deviation}
          notificationQueue={notificationQueue}
          ignorePreselectedCollections={
            popover.params?.ignorePreselectedCollections
          }
          onClose={removePopover}
        />
      }
      placement="bottom"
      isVisible={popover.isOpen}
      offsetModifier={offsetModifier}
      onClickOutside={isMobile ? undefined : removePopover}
    >
      <AddToPrivateCollectionButton
        deviation={deviation}
        onClick={togglePopover}
      />
    </PositionOnlyPopperPopover>
  );
};
AddToPrivateCollectionButtonWithPopover.displayName =
  'AddToPrivateCollectionButtonWithPopover';

export default AddToPrivateCollectionButtonWithPopover;
